<template>
  <div style="position: relative;">
    <el-form ref="techAchievementFilter" :model="techAchievementList" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="技术服务成果" prop="formFilter.techServiceAchievement">
          <el-input class="filter-item" v-model="techAchievementList.formFilter.techServiceAchievement"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="合作单位" prop="formFilter.cooperationUnit">
          <el-input class="filter-item" v-model="techAchievementList.formFilter.cooperationUnit"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="科技特派员" prop="formFilter.scienceTechnician">
          <el-input class="filter-item" v-model="techAchievementList.formFilter.scienceTechnician"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetTechAchievement">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshTechAchievement(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('techAchievement:all')"
                   @click="onTechAchievementAddClick()">
          新增
        </el-button>
        <el-button slot="operator" type="success" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('techAchievement:all')"
                   @click="onImportClick()">
          导入
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="techAchievement" :data="techAchievementList.TechAchievement.impl.dataList" :size="defaultFormItemSize" @sort-change="techAchievementList.TechAchievement.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
                  highlight-current-row @current-change="techAchievementList.TechAchievement.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="techAchievementList.TechAchievement.impl.getTableIndex" />
          <el-table-column label="技术服务成果" prop="techServiceAchievement" sortable="custom">
          </el-table-column>
          <el-table-column label="技术成果合作单位" prop="cooperationUnit" sortable="custom">
          </el-table-column>
          <el-table-column label="科技特派员" prop="scienceTechnician" sortable="custom">
          </el-table-column>
          <el-table-column label="图片地址" prop="imageUrl">
            <template slot-scope="scope">
              <el-image v-for="item in parseUploadData(scope.row.imageUrl, {id: scope.row.id, fieldName: 'imageUrl', asImage: true})"
                        :preview-src-list="getPictureList(scope.row.imageUrl, {id: scope.row.id, fieldName: 'imageUrl', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <span v-if="!scope.row.imageUrl">无图片</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remark" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime" sortable="custom" width="180px">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="150px">
            <template slot-scope="scope">
              <el-button @click.stop="onTechAchievementEditClick(scope.row)" type="text" :size="defaultFormItemSize"
                         :disabled="!checkPermCodeExist('techAchievement:all')">
                编辑
              </el-button>
              <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                         :disabled="!checkPermCodeExist('techAchievement:all')">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="techAchievementList.TechAchievement.impl.totalCount"
            :current-page="techAchievementList.TechAchievement.impl.currentPage"
            :page-size="techAchievementList.TechAchievement.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="techAchievementList.TechAchievement.impl.onCurrentPageChange"
            @size-change="techAchievementList.TechAchievement.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>

    <el-dialog title="导入技术成果信息" :visible.sync="techAchievementList.importDialogVisible" width="500px" :close-on-click-modal="false"
               :close-on-press-escape="false"
    >
      <el-upload
        ref="upload"
        :auto-upload="false"
        :on-change="onFileChange"
        :file-list="techAchievementList.fileList"
        accept=".xlsx,.xls"
        drag
        :limit="1"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">仅支持xlsx/xls格式文件，且不超过10MB</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button :size="defaultFormItemSize" @click="techAchievementList.importDialogVisible = false">取消</el-button>
        <el-button type="primary" :size="defaultFormItemSize" :loading="techAchievementList.isImporting" @click="onImportSubmitClick">确定导入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapGetters } from 'vuex';
import { findItemFromList } from '@/utils';
// eslint-disable-next-line no-unused-vars
import rules from '@/utils/validate.js';
import { TableWidget } from '@/utils/widget.js';
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
import { TechAchievementController } from '@/api';

export default {
  name: 'techAchievementList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      fit: 'scale-down',
      techAchievementList: {
        formFilter: {
          techServiceAchievement: undefined,
          cooperationUnit: undefined,
          scienceTechnician: undefined
        },
        formFilterCopy: {
          techServiceAchievement: undefined,
          cooperationUnit: undefined,
          scienceTechnician: undefined
        },
        TechAchievement: {
          impl: new TableWidget(this.loadTechAchievementWidgetData, this.loadTechAchievementVerify, true, true)
        },
        importDialogVisible: false,
        isImporting: false,
        fileList: [],
        isInit: false
      }
    }
  },
  methods: {
    onResetTechAchievement () {
      this.$refs.techAchievementFilter.resetFields();
      this.refreshTechAchievement(true);
    },
    loadTechAchievementWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        techAchievementDtoFilter: {
          techServiceAchievement: this.techAchievementList.formFilterCopy.techServiceAchievement,
          cooperationUnit: this.techAchievementList.formFilterCopy.cooperationUnit,
          scienceTechnician: this.techAchievementList.formFilterCopy.scienceTechnician
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        TechAchievementController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          if (this.techAchievementList.TechAchievement.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.techAchievementList.TechAchievement.impl.currentRow.id, 'id');
              this.$refs.techAchievement.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadTechAchievementVerify (data) {
      return true;
    },
    refreshTechAchievement (resetPage) {
      this.techAchievementList.formFilterCopy = JSON.parse(JSON.stringify(this.techAchievementList.formFilter));
      if (resetPage) {
        this.techAchievementList.TechAchievement.impl.refreshTable(true, 1);
      } else {
        this.techAchievementList.TechAchievement.impl.refreshTable();
      }
      if (!this.techAchievementList.isInit) {
        // 初始化下拉数据
      }
      this.techAchievementList.isInit = true;
    },
    onTechAchievementAddClick () {
      let params = {
        mode: 'add',
        closeVisible: 1
      };
      this.$router.push({name: 'techAchievementForm', query: params});
    },
    onTechAchievementEditClick (row) {
      let params = {
        id: row.id
      };
      params.closeVisible = 1;
      this.$router.push({name: 'techAchievementForm', query: params});
    },
    onDeleteClick (row) {
      this.$confirm('确定要删除该技术成果信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        TechAchievementController.delete(this, { id: row.id }).then(res => {
          this.$message.success('删除成功');
          this.refreshTechAchievement(false);
        }).catch(e => {
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    onImportClick () {
      this.techAchievementList.fileList = [];
      this.techAchievementList.importDialogVisible = true;
    },
    onFileChange (file, fileList) {
      this.techAchievementList.fileList = fileList.slice(-1);
    },
    onImportSubmitClick () {
      if (this.techAchievementList.fileList.length === 0) {
        this.$message.warning('请选择要导入的文件');
        return;
      }
      this.techAchievementList.isImporting = true;
      let formData = new FormData();
      formData.append('file', this.techAchievementList.fileList[0].raw);
      TechAchievementController.importData(this, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.success) {
          let data = res.data;
          this.$message.success(`导入完成：成功${data.successCount}条，失败${data.failCount}条`);
          if (data.failMessages && data.failMessages.length > 0) {
            this.$alert(data.failMessages.join('<br/>'), '导入失败详情', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定'
            });
          }
          this.techAchievementList.importDialogVisible = false;
          this.refreshTechAchievement(true);
        } else {
          this.$message.error(res.message);
        }
      }).catch(e => {
        this.$message.error('导入失败');
      }).finally(() => {
        this.techAchievementList.isImporting = false;
      });
    },
    onResume () {
      this.refreshTechAchievement();
    },
    formInit () {
      this.refreshTechAchievement();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>

<style scoped>
</style>
